import { register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  document.addEventListener('click', () => { el.blur() })

  document.addEventListener('scroll', () => {
    if ((window.scrollY > 1000)) {
      el.classList.add(`${componentPrefix}--visible`)
    } else {
      el.classList.remove(`${componentPrefix}--visible`)
    }
  })
}

register('scrollToTop', component)
